<template>
  <div class="alert text-center" :class="[`alert-${infoType}`, ...addedClassList]" role="alert" :style="{
    top: `${top}px`,
    left: `${left}px`,
    'z-index': isMobile ? 10 : 4
  }">
    <div class="d-flex w-100 ">
      <strong>
        <fa :icon="infoType === 'success' ? 'check' : 'exclamation-circle'"></fa>
        <span class="desc" v-html="infoText"></span>
      </strong>
      <span @click="closeInfoBanner" class="icon__close text-white">
        <fa icon="times"></fa>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { getElementClientHeight, getElementWidth } from '../../utils/BOM';
export default {
  name: 'InfoBanner',
  props: {
    infoType: {
      type: String,
      required: true,
      validator: val => {
        const validTypeList = ['success', 'warning', 'danger'];
        const isValidType = validTypeList.includes(val);
        if (isValidType) {
          return true;
        } else {
          console.error('type must be one of: ', validTypeList.join(' '));
          return false;
        }
      }
    },
    addedClassList: {
      type: Array,
      default: () => []
    },
    infoText: {
      type: String,
      required: true
    },
    displayDuration: {
      type: Number
    }
  },
  data() {
    return {
      top: 0,
      left: 0
    };
  },
  computed: {
    ...mapGetters(['isMobile'])
  },
  methods: {
    closeInfoBanner() {
      this.$emit('onClose');
    },
    setPosition() {
      this.top = 0;
      this.left = 0;

      const sidebarEle = document.querySelector('.sidebar');
      if (sidebarEle) {
        this.left = getElementWidth(sidebarEle);
      } else {
        this.left = 0;
      }

      const omnibarEle = document.querySelector('.omnibar');
      if (omnibarEle) {
        this.top += getElementClientHeight(omnibarEle);
      } else {
        this.top += 0;
      }

      const subheaderEle = document.querySelector('.fixed-header');
      if (subheaderEle) {
        this.top += getElementClientHeight(subheaderEle);
      } else {
        this.top += 0;
      }
    }
  },
  mounted() {
    // Set position of banner on non-mobile devices. The default position will be used on mobile devices, which is (0, 0).
    if (!this.isMobile) {
      this.setPosition();
      this.intervalTimer = setInterval(() => {
        this.setPosition();
      }, 500);
    }

    if (this.displayDuration) {
      setTimeout(() => {
        this.closeInfoBanner();
      }, this.displayDuration);
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalTimer);
  }
};
</script>

<style lang="scss" scoped>
.alert {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  padding: 0;
  line-height: 2rem;

  &>div {
    justify-content: space-between;
    align-items: center;
  }
}

strong {
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    width: 2rem;
    margin-left: 0.5rem;
  }
}

.desc {
  padding: 0.25rem;
  padding-left: 0.75rem;
  line-height: 1.5rem;
  text-align: left;
}

.icon__close {
  width: 3rem;
  padding: 0.25rem 1rem;
  margin-right: 0rem;
  cursor: pointer;
}
</style>
